module.exports = __webpack_public_path__ + "img/AL281-2.b0546c96.jpg";